import React from 'react';
import './blog-post.css';
import wir1 from './pictures/wir1.JPG';
import wir2 from './pictures/wir2.JPG';
import wir3 from './pictures/wir3.JPG';


//import reportWebVitals from './reportWebVitals';

const WIR23 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                  <h2>Women in Research Panel Recap</h2>
                  <p class="site-post-meta">March 13, 2023</p>
                  <hr></hr>
                </section>
                <section>
                    <p>
                        On February 16th, WiC hosted our Women in Research Panel in conjunction with LEAP to promote women in academia. 
                        It was a major success and we want to thank everyone who came! We hosted our amazing panelists from the Allen 
                        School, including Maya Cakmak, Leilani Battle, Franzi Roesner, Amy Zhang, and Maureen Daum. All of the 
                        attendees found this event very useful and really enjoyed listening to the experiences of women researchers 
                        in the Allen School and learning about research opportunities in the Allen School.

                        Thank you once again everyone for coming to the event. We hope you were able to learn new things while 
                        enjoying our panel and supporting WiC and LEAP’s work!
                    </p>
                    <img src={wir1} alt="Women in Computing officers with Speakers"/>
                    <img src={wir2} alt="Speakers and attendees"/>
                    <img src={wir3} alt="Speakers and attendees"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default WIR23;